module.exports = __webpack_public_path__ + "img/wuhan01.ba99d1c7.png";